// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"556":"forum/components/LogInSection","857":"forum/components/SignUpSection"}[chunkId] + ".js";
};